import React from 'react'
import styled from 'styled-components'
import { NewCheckboxProps } from './types'

const Text = styled.span<{ $value?: string, $checked?: boolean}>`
  font-size: .875rem;
  margin-left: .5rem;
  line-height: 1.5rem;
  cursor: pointer;

  ${props => props.$value === 'all' && `
    font-size: .75rem;
    font-weight: 700;
    line-height: 1;
    background-color: ${props.$checked ? props.theme.members.colors.lightGreen : props.theme.members.colors.silver._10};
    padding: 8px 16px;
    color: ${props.$checked ? props.theme.members.colors.white : props.theme.members.colors.emeraldGreen._60};
    border-radius: 40px;
    margin-left: 0;
  `}

  &.-disabled {
    color: ${props => props.theme.members.colors.silver._100};
    cursor: not-allowed;
  }
`

const CustomNewCheckbox = styled.span<{ $value: NewCheckboxProps['value']}>`
  display: inline-block;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  width: 1rem;
  height: 1rem;
  border: 1px solid ${props => props.theme.members.colors.silver._70};
  background-color: ${props => props.theme.members.colors.white};
  margin-top: 1px;

  ${props => props.$value === 'all' && `
    display: none;
  `}

  &::after {
    content: '';
    display: block;
    position: absolute;
    transform: rotate(45deg);
    background: none;
    border: 2px solid ${props => props.theme.members.colors.white};
    border-top: 0;
    border-left: 0;
    width: .437rem;
    height: .75rem;
    left: 4px;
    top: -1px;
    opacity: 0;
  }

  &.-disabled {
    border: 1px solid ${props => props.theme.members.colors.silver._30} !important;
    background-color: ${props => props.theme.members.colors.silver._30} !important;
  }

  &.-disabled::after {
    border-color: ${props => props.theme.members.colors.silver._70} !important;
  }
`

const HiddenNewCheckbox = styled.input`
  display: none;

  &:checked + ${CustomNewCheckbox}::after {
    opacity: 1;
  }

  &:checked + ${CustomNewCheckbox} {
    border: 1px solid ${props => props.theme.members.colors.lightGreen};
    background-color: ${props => props.theme.members.colors.lightGreen};
  }
`

const Label = styled.label`
  display: inline-flex;
  align-items: center;
  margin-bottom: 0;

  &.-disabled ${CustomNewCheckbox} {
    color: ${props => props.theme.members.colors.silver._100};
    cursor: not-allowed;
  }

  &.-disabled ${CustomNewCheckbox}::before {
    background-color: #dbdde3;
    border-color: ${props => props.theme.members.colors.silver._30};
  }
`

export const StyledNewCheckbox: React.FC<NewCheckboxProps> = (props: NewCheckboxProps) => {
  const disabledClass = props.disabled ? '-disabled' : ''
  const textClass = [disabledClass, 'text-member-gray-100'].join(' ')

  return (
    <div data-cy={props.value}>
      <Label className={disabledClass}>
        <HiddenNewCheckbox
          type='checkbox'
          checked={props.checked}
          disabled={props.disabled}
          onChange={props.onChange}
        />
        <CustomNewCheckbox $value={props.value} className={disabledClass} data-cy="custom-checkbox" />
        <Text className={textClass} $value={props.value} $checked={props.checked}
          data-cy="checkbox-label-text">
          {props.value === 'all' && props.checked
            ? props.resetLabel
            : props.label}
        </Text>
      </Label>
    </div>
  )
}
